import Metadata from '../requests/apa/Metadata';

export const OFFERS_V4_FLAG_KEY = 'offers_v4_flag';

/**
 * Resuelve el indicador de funcionalidad de ofertas v4 para una clave de país determinada.
 *
 * Orden de resolución: countryKey → default → false
 * Cualquier error (Metadata.get, JSON.parse o de otro tipo) devuelve { enabled: false }.
 *
 * @param {string} countryKey - Identificador del país (p. ej., 'mexico')
 * @returns {{ enabled: boolean }}
 */
export function getOffersV4Flag(countryKey) {
    try {
        const raw = Metadata.get(OFFERS_V4_FLAG_KEY);
        const parsed = JSON.parse(raw);

        if (parsed && countryKey && parsed[countryKey] !== undefined) {
            return { enabled: Boolean(parsed[countryKey].enabled) };
        }

        if (parsed && parsed['default'] !== undefined) {
            return { enabled: Boolean(parsed['default'].enabled) };
        }

        return { enabled: false };
    } catch (e) {
        return { enabled: false };
    }
}



// WEBPACK FOOTER //
// ./src/utils/offersV4FlagResolver.js